import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserEnroll from '../reducers';

export const selectUserEnrollFeatureState = createFeatureSelector<fromUserEnroll.UserEnrollState>(
  fromUserEnroll.userEnrollFeatureKey
);

export const selectUserEnrollState = createSelector(selectUserEnrollFeatureState, state => state.userEnrollState);
